import Vue from 'vue';
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#495ed8',
				secondary: '#424242',
				accent: '#6fa8dc',
				// one_more_accent: '#5681ab',
				one_more_accent: '#68a5c5',
				error: '#ff7a72',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
				background: '#f8f8f8',
			},
			// dark: {
			// 	primary: '#495ed8',
			// 	secondary: '#424242',
			// 	accent: '#6fa8dc',
			// 	// one_more_accent: '#5681ab',
			// 	one_more_accent: '#68a5c5',
			// 	error: '#ff7a72',
			// 	info: '#2196F3',
			// 	success: '#4CAF50',
			// 	warning: '#FFC107',
			// 	background: '#f8f8f8',
			// }
		}
	}
})
